import { render, staticRenderFns } from "./AddShippingModalOther.vue?vue&type=template&id=6e4959d0&scoped=true&"
import script from "./AddShippingModalOther.vue?vue&type=script&lang=js&"
export * from "./AddShippingModalOther.vue?vue&type=script&lang=js&"
import style0 from "./AddShippingModalOther.vue?vue&type=style&index=0&id=6e4959d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4959d0",
  null
  
)

export default component.exports